import React, { useState } from 'react';
import SolutionCalc from './components/solutionCalc/SolutionCalc';
import styled from 'styled-components';
import {
  Paper,
  MainTitle,
  MainCalWrapper,
  MainCalc,
  MainLabel,
  MainInput,
  MainActions,
  Hr,
  MainSelect,
  MainCircle,
  MainFlex,
  Parag,
  MainFlexColumn,
} from './styled/stylezz';

const CircleRLine = styled.div`
  &&& {
    position: absolute;
    width: 50%;
    height: 3px;
    background: red;
    top: 50%;
    left: 50%;
    &:before {
      content: 'R';
      position: absolute;
      left: 50%;
      top: 5px;
      transform: translateX(-50%);
    }
  }
`;

const CircleDline = styled(CircleRLine)`
  &&& {
    width: 100%;
    left: 0;
    transform: rotate(-10deg);
    &:before {
      content: 'D';
      position: absolute;
      left: 50%;
      top: 5px;
      transform: translateX(-50%);
    }
  }
`;

const App = () => {
  const [inputA, setInputA] = useState('');
  const [demension, setDemension] = useState('r');

  const [solutionShow, setSolutionShow] = useState(false);

  const handleSolution = () => {
    setSolutionShow(true);
  };

  const handleCleanInput = () => {
    setInputA('');
    setDemension('r');

    setSolutionShow(false);
  };

  return (
    <React.Fragment>
      <Paper>
        <MainTitle>Калькулятор</MainTitle>
        <MainCalWrapper>
          <span style={{ fontSize: '20px' }}>Введите данные:</span>
          <Hr />
          <MainCalc>
            <MainFlex>
              <MainFlexColumn>
                <Parag>Выберите величину:</Parag>
                <MainSelect onChange={(e) => setDemension(e.target.value)}>
                  <option value={'r'}> Радиус</option>
                  <option value={'d'}> Диаметр</option>
                </MainSelect>

                <MainLabel>
                  {demension} =
                  <MainInput
                    type="number"
                    value={inputA}
                    style={{ marginRight: '0' }}
                    onChange={(e) => setInputA(e.target.value)}
                  />
                </MainLabel>
              </MainFlexColumn>

              <MainCircle>
                {demension === 'r' ? <CircleRLine /> : <CircleDline />}
              </MainCircle>
            </MainFlex>
          </MainCalc>
          <Hr />

          <MainActions>
            <button onClick={handleSolution}>Решение</button>
            <button onClick={handleCleanInput}>Сбросить</button>
          </MainActions>
        </MainCalWrapper>

        {solutionShow && (
          <SolutionCalc inputA={+inputA} demension={demension} />
        )}
      </Paper>
    </React.Fragment>
  );
};

export default App;
